import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isBefore, startOfDay } from 'date-fns';

export const beforeDateValidator = (dateToCompareFieldName: string): ValidatorFn => {
  return (control: AbstractControl) => {
    const dateToCompare = control.root.get(dateToCompareFieldName);

    if (!dateToCompare) {
      return null;
    }

    const controlDate = startOfDay(new Date(control.value));
    const compareDate = startOfDay(new Date(dateToCompare.value));

    return isBefore(controlDate, compareDate) ? { isBeforeDate: true } : null;
  };
};
